import { Configuration, LogLevel } from '@azure/msal-browser';

// Microsoft Entra ID Configuration for Tenant: 65bceaf6-e018-41d8-873a-0cf41915bc5d
export const MSALConfig: Configuration = {
  auth: {
    clientId: 'd6fc8dba-886a-4cd5-8fd6-800e2232849a', // App Registration Client ID
    authority: 'https://login.microsoftonline.com/65bceaf6-e018-41d8-873a-0cf41915bc5d',
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ['User.Read'],
};